import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Heading, Paragraph } from '@scentregroup/ui'
import MoviePoster from '../../movie-poster'
import { slugify } from '../../../helpers'
import style from './index.module.scss'

export const fromMovie = (centreId, date) => m => ({
  title: m.title,
  link: `/${centreId}/movie/${m.id}/${slugify(m.title)}${
    date ? `/${date}` : ''
  }`,
  image: m.image,
  classification: m.classification,
  category: m.genres && m.genres[0],
})

const Card = ({ className, link, image, category, title, classification }) => (
  <Link className={classNames(style.Card, className)} to={link}>
    <MoviePoster className={style.cardImage} image={image} />
    <Paragraph className={style.cardCategory}>{category}</Paragraph>
    <Heading
      type="extrasmall"
      className={style.cardTitle}
      data-test-id="movie-title"
    >
      {title}
    </Heading>
    <Paragraph className={style.cardClassification}>{classification}</Paragraph>
  </Link>
)

Card.propTypes = {
  className: PropTypes.string,
  link: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  category: PropTypes.string,
  title: PropTypes.string.isRequired,
  classification: PropTypes.string.isRequired,
}
Card.defaultProps = {
  category: '',
}

export default Card
